<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>

                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                            prop="id"
                            label="id"
                            width="300px">
                        </el-table-column>
                        <el-table-column
                            prop="Name"
                            label="角色名称">
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="300px">
                            <template slot-scope="scope">
                                <el-button type="success" plain @click="setPower(scope.row)">设置权限</el-button>
                                  <el-button type="danger" plain @click="del(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="添加角色" :visible.sync="dialogFormVisible" width="400px">
            <el-form :model="newModel"  :rules="rules" ref="ruleForm" label-width="120px">
                <el-form-item label="角色名称：" prop="Name">
                    <el-input placeholder="请输入角色标题" v-model="newModel.Name"></el-input>
                </el-form-item>
                <el-form-item label="角色描述：" prop="Desc">
                    <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="请输入角色描述："
                    v-model="newModel.Desc">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    <el-dialog :visible.sync="PowerdialogForm" width="50%">
      <el-form ref="form"  label-width="140px">
        <el-row>
          <div style="margin-left:50px;">角色菜单权限：</div>
          <el-tree
            ref="tree"
            :data="menus"
            style="margin-left:40px;"
            :default-checked-keys="defaultChecked"
            :check-strictly="true"
            show-checkbox
            :default-expand-all="true"
            node-key="code"
            :props="defaultProps">
          </el-tree>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="savePower">保 存</el-button>
          <el-button @click="PowerdialogForm = false">关 闭</el-button>
      </span>
    </el-dialog>
    </div>
</template>
<script>
import { getRole, delRole,addRole,setRolePower } from '@/api/role'
import { constantRoutes } from "@/router"
export default {
    data(){
        return {
            dialogFormVisible:false,
            PowerdialogForm:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            defaultChecked: [],
            menus: [],
            editId: '',
            defaultProps: {
                children: 'children',
                label: function(a) {
                return a.meta.navtitle
                }
            },
            queryModel:{
                pSize:20,
                pIndex:1,
            },newModel:{
                Name:"",
                Desc:"",
            },
            rules: {
                Name: [
                    { required: true, message: '请填写角色名称', trigger: 'blur' },
                    { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                ]
            },
            tableData:[]
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
        this.menus = constantRoutes[0].children.filter(item => {
            return item.meta.showInMenu == true
        })
    },
    methods: {
        setPower(info) {
            this.defaultChecked = info.Power ? JSON.parse(info.Power) : []
            this.$nextTick(() => {
                this.$refs.tree.setCheckedKeys(this.defaultChecked);
            });
            this.editId = info.id
            this.PowerdialogForm = true
        },
        savePower(){
            let menuCodes = []
            this.$refs.tree.getCheckedNodes(false, true).map(item => {
                menuCodes.push(item.code)
            })
            var power = JSON.stringify(menuCodes)
            setRolePower(this.editId, {Power:power})
            .then(() => {
              this.$message({
                message: "权限设置成功！",
                type: 'success'
              });
              this.query(),
              this.PowerdialogForm = false
            })
        },
        submitForm() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    addRole(this.newModel)
                    .then(() => {
                    this.$message({
                        message: "新增成功！",
                        type: 'success'
                    });
                    this.query()
                    this.dialogFormVisible = false
                    })
                    .catch(err => {
                        console.log(err)
                    })
                } else {
                    return false;
                }
            });
        },
        del(scope){
            this.$confirm('确认删除该角色吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                delRole(scope.id)
                    .then(() => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.tableData.forEach((item, index, arr)=>{
                            if(item==scope){
                                arr.splice(index, 1);
                            }
                        });
                    })
                    .catch(err => {
                        console.log(err)
                    })
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        query(){
            this.isLoading=true;
            
            getRole(this.queryModel).then(res => {
                this.tableData=res.data.Result
                this.total=res.data.TotalCount
                this.isLoading = false
                })
            .catch(err => {
                console.log(err)
                this.isLoading = false
            });
        },
        add(){
            this.newModel={
                Name:"",
                Desc:""
            };
            this.dialogFormVisible=true;
        },
        reset(){
            this.queryModel={
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>